import { Map, List } from 'immutable';
import store from '@/store/store';
import { REF_PATH as EXPENSES_TYPE_REF_PATH }
  from '@/component/dict/complex/expensestype/Const';
import { REF_PATH as DOCUMENT_TYPE_REF_PATH }
  from '@/component/dict/simple/documenttype/Const';
import { REF_PATH as INSURANCECOMPANY_REF_PATH }
  from '@/component/dict/simple/insurancecompany/Const';
import { REF_PATH as INSPECTIONCOMPANY_REF_PATH }
  from '@/component/dict/simple/inspectioncompany/Const';
import { REF_PATH as OWNER_REF_PATH }
  from '@/component/dict/simple/owner/Const';
import { REF_PATH as VESSEL_BROKER_REF_PATH }
  from '@/component/dict/simple/vesselbroker/Const';
import { REF_PATH as FORWARDER_REF_PATH }
  from '@/component/dict/simple/forwarder/Const';
import { REF_PATH as BUYER_REF_PATH }
  from '@/component/dict/simple/buyer/Const';
import { REF_PATH as SELLER_REF_PATH }
  from '@/component/dict/simple/supplier/Const';
import { REF_PATH as PRODUCER_TYPE_REF_PATH }
  from '@/component/dict/simple/producer/Const';
import { REF_PATH as BANK_REF_PATH }
  from '@/component/dict/simple/bank/Const';
import { REF_PATH as ORIGIN_TYPE_REF_PATH }
  from '@/component/dict/simple/origin/Const';
import momentLocalizer from 'react-widgets-moment';
import moment from 'moment';

moment.locale('en');
momentLocalizer();

/**
 * sort order
 */
export const so = (result, order) => order == 'desc' ? result * -1 : result;  //eslint-disable-line

const getSimpleDictValues = refName =>
  store.getState().getIn(['references', 'simple', refName], new List());

const getTotalNum = (payment, property) => {
  let total = parseFloat(payment[property]) || 0;
  if (payment.payments || payment.payments.length) {
    total += payment.payments.map(p => getTotalNum(p, property)).reduce((sum, p) => sum + p, 0.00);
  }
  return total;
};

export const numberSort = (property, a, b, order) => {
  const v1 = parseFloat(a[property]) || 0;
  const v2 = parseFloat(b[property]) || 0;
  if (v1 == v2) {
    return 0;
  }
  return so(v1 > v2 ? 1 : -1, order);
};

const numberSortDeep = (property, a, b, order) => {
  const v1 = getTotalNum(a, property);
  const v2 = getTotalNum(b, property);
  if (v1 == v2) {
    return 0;
  }
  return so(v1 > v2 ? 1 : -1, order);
};

const findLatestDate = (payment, property) => {
  let dates = payment[property] == null ? [] : [moment(payment[property], 'DD MMM YYYY')];
  if (payment.payments || payment.payments.length) {
    dates = dates.concat(payment.payments.map(p => findLatestDate(p, property))
      .filter(p => p != null).map(p => moment(p)));
  }
  return dates.length ? moment.max(dates) : null;
};

const findClosestDate = (payment, property) => {
  const now = moment().startOf('day');
  let dates = payment[property] == null ? [] : [moment(payment[property], 'DD MMM YYYY')];
  if (payment.payments || payment.payments.length) {
    dates = dates.concat(payment.payments.map(p => findClosestDate(p, property))
      .filter(p => p != null).map(p => moment(p)));
  }
  return dates.length ?
    dates.reduce((result, d) =>         //eslint-disable-line
      Math.abs(now.diff(result)) > Math.abs(now.diff(d)) ? d : result, dates[0]) : null;
};

const sortDate = (property, a, b, order) => {
  const v1 = findLatestDate(a, property);
  const v2 = findLatestDate(b, property);

  return so((function () { //eslint-disable-line
    if (v1 == v2) {
      return 0;
    }
    if (v1) {
      if (v2) {
        return v2.isBefore(v1) ? -1 : 1;
      }
      return -1;
    }
    if (v2) {
      return 1;
    }
    return v1.isBefore(v2) ? -1 : 1;
  }()), order);
};

export const sortSimpleDate = (property, a, b, order) => {
  const v1 = (a[property] && moment(a[property], 'DD MMM YYYY')) || '';
  const v2 = (b[property] && moment(b[property], 'DD MMM YYYY')) || '';

  if (v1 == v2) {
    return 0;
  }
  if (v1) {
    if (v2) {
      return so(v2.isBefore(v1) ? -1 : 1, order);
    }
    return so(-1, order);
  }
  if (v2) {
    return so(1, order);
  }
  return so(v1.isBefore(v2) ? -1 : 1, order);
};

const sortDateClosestInternal = (property, a, b, order) => {
  const v1 = findClosestDate(a, property);
  const v2 = findClosestDate(b, property);

  return so((function () { //eslint-disable-line
    if (v1 == v2) {
      return 0;
    }
    if (v1) {
      if (v2) {
        return v2.isBefore(v1) ? 1 : -1;
      }
      return 1;
    }
    if (v2) {
      return -1;
    }
    return v1.isBefore(v2) ? 1 : -1;
  }()), order);
};

const compareDictValues = (dict, property, a, b, order) => {
  const v1 = a[property];
  const v2 = b[property];
  if (v1 == v2) {
    return 0;
  }
  const v1name = dict.find(dt => dt.get('id') == v1, this, new Map()).get('name') || '';
  const v2name = dict.find(dt => dt.get('id') == v2, this, new Map()).get('name') || '';
  return so(v1name.toLowerCase() > v2name.toLowerCase() ? 1 : -1, order);
};

const sortCondition = (condition, a, b, order) => {
  const v1 = condition(a);
  const v2 = condition(b);
  if (v1 == v2) {
    return 0;
  }
  return so(v1 > v2 ? 1 : -1, order);
};

export const sortBoolean = (property, a, b, order) => {
  const v1 = a[property];
  const v2 = b[property];
  if (v1 == v2) {
    return 0;
  }
  return so(v1 > v2 ? 1 : -1, order);
};

const creditPaymentHasAtLeastOneApproved = (row) => {
  const payments = row.payments || [];
  if (payments.length) {
    return payments.some(r => r.approve);
  }
  return false;
};

const creditPaymentHasEveryPaid = (row) => {
  const payments = row.payments || [];
  if (payments.length) {
    return payments.every(r =>
      (!row.isDebit || r.dueAmount > 0) && !((r.dueAmount || 0) - (r.paymentAmount || 0)));
  }
  return false;
};

const sortPayGreenZone =
  r => r.approve || !r.isDebit || creditPaymentHasAtLeastOneApproved(r)
  || creditPaymentHasEveryPaid(r);

const sortPayYellowZone =
  r => ((r.approve || !r.isDebit) && !r.outstanding)
  || (!r.approve && creditPaymentHasEveryPaid(r));

export const sortPay = (a, b, order) =>
  sortCondition(sortPayGreenZone, a, b, order)
  || sortCondition(sortPayYellowZone, a, b, order);

export const sortDRCR = (a, b, order) => sortBoolean('isDebit', a, b, order);

export function sortContractNumberFunc(preformatter) {
  return (a, b, order) => {
    const v1 = preformatter(a);
    const v2 = preformatter(b);
    if (v1 == v2) {
      return 0;
    }
    return so((v1 || '').toLowerCase() > (v2 || '').toLowerCase() ? 1 : -1, order);
  };
}

export function sortSimpleTextFunc(property) {
  return (a, b, order) => {
    if (a == b) {
      return 0;
    }
    return so((a && a[property] || '').toLowerCase() >
    (b && b[property] || '').toLowerCase() ? 1 : -1, order);
  };
}

export function sortSimpleText(a, b, order, property) {
  if (a == b) {
    return 0;
  }
  const aLc = (a && a[property] || '').toLowerCase();
  const bLc = (b && b[property] || '').toLowerCase();
  if (aLc == bLc) {
    return 0;
  }
  return so(aLc > bLc ? 1 : -1, order);
}


export function sortDocumentNumber(a, b, order) {
  const v1 = a.documentNumber;
  const v2 = b.documentNumber;
  if (v1 == v2) {
    return 0;
  }
  return so((v1 || '').toLowerCase() > (v2 || '').toLowerCase() ? 1 : -1, order);
}

export const sortDocumentTypeFunc = () =>
  (a, b, order) => compareDictValues(getSimpleDictValues(DOCUMENT_TYPE_REF_PATH),
    'documentType', a, b, order);

export const sortTypeFunc = () =>
  (a, b, order) => compareDictValues(getSimpleDictValues(EXPENSES_TYPE_REF_PATH),
    'expensesType', a, b, order);

export const sortCounterpartyFunc = () =>
  (a, b, order) => compareDictValues(getSimpleDictValues(INSURANCECOMPANY_REF_PATH)
    .concat(getSimpleDictValues(INSPECTIONCOMPANY_REF_PATH))
    .concat(getSimpleDictValues(OWNER_REF_PATH))
    .concat(getSimpleDictValues(VESSEL_BROKER_REF_PATH))
    .concat(getSimpleDictValues(FORWARDER_REF_PATH))
    .concat(getSimpleDictValues(BUYER_REF_PATH))
    .concat(getSimpleDictValues(SELLER_REF_PATH))
    .concat(getSimpleDictValues(PRODUCER_TYPE_REF_PATH)),
  'counterparty', a, b, order);

export const sortDueAmount = (a, b, order) => numberSortDeep('dueAmount', a, b, order);

export const sortEstimatedDueAmount = (a, b, order) =>
  numberSortDeep('estimatedDueAmount', a, b, order);

export const sortDueDate = (a, b, order) => sortDateClosestInternal('dueDate', a, b, order);

export const sortBankRepaymentDate = (a, b, order) =>
  sortDateClosestInternal('bankRepaymentDate', a, b, order);

export const sortEstimatedDueDate = (a, b, order) =>
  sortDateClosestInternal('estimatedDueDate', a, b, order);

export const sortPaymentAmount = (a, b, order) => numberSortDeep('paymentAmount', a, b, order);

export const sortPaymentDate = (a, b, order) => sortDate('paymentDate', a, b, order);

export const sortOutstanding = (a, b, order) => numberSort('outstanding', a, b, order);

export const sortBankingCost = (a, b, order) => numberSort('bankingCost', a, b, order);

export const sortBank = (a, b, order) =>
  compareDictValues(getSimpleDictValues(BANK_REF_PATH), 'bank', a, b, order);

export const sortOrigin = (a, b, order) =>
  compareDictValues(getSimpleDictValues(ORIGIN_TYPE_REF_PATH),
    'origin', a, b, order);

export const sortId = (a, b, order) => numberSort('id', a, b, order);
